var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"round"},[_c('input',{attrs:{"type":"checkbox","id":_vm.id,"name":_vm.name || false},domProps:{"checked":_vm.value},on:{"input":function($event){return _vm.$emit('input', $event.target.checked)}}}),_c('label',{attrs:{"for":_vm.id}})])
}
var staticRenderFns = []

export { render, staticRenderFns }